'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.provinces = provinces;
function provinces() {
  return [{
    value: 'AB',
    text: 'Alberta'
  }, {
    value: 'BC',
    text: 'British Columbia'
  }, {
    value: 'MB',
    text: 'Manitoba'
  }, {
    value: 'NB',
    text: 'New Brunswick'
  }, {
    value: 'NL',
    text: 'Newfoundland and Labrador'
  }, {
    value: 'NS',
    text: 'Nova Scotia'
  }, {
    value: 'NT',
    text: 'Northwest Territories'
  }, {
    value: 'NU',
    text: 'Nunavut'
  }, {
    value: 'ON',
    text: 'Ontario'
  }, {
    value: 'PE',
    text: 'Prince Edward Island'
  }, {
    value: 'QC',
    text: 'Quebec'
  }, {
    value: 'SK',
    text: 'Saskatchewan'
  }, {
    value: 'YT',
    text: 'Yukon'
  }];
}


//////////////////
// WEBPACK FOOTER
// ./src/v2/helpers/provinces.js
// module id = 1710
// module chunks = 0